export default "__VITE_ASSET__6ttRv$LO50lh4siwzZRgfg__"